import { CartItemDto, CartCheckoutDto, CartStorageDto, CartTotalsDto } from "../dto";
import { GeneralUtil } from "./general";

export class CartUtil {

	private static readonly ITEM_FIELDS = [
		'IdArticulo', 'IdUnidadMedida', 'Cantidad'
	] as const;

	private static readonly CHECKOUT_FIELDS = [
		'IdFormaEnvio', 'DetFormaEnvio',
		'IdDireccion', 'FechaEntrega',
		'HorarioPreferencial', 'Observaciones',
		'FlagRecojeOtro', 'NombreRecojeOtro',
		'NumDocRecojeOtro', 'TelefRecojeOtro'
	] as const;

	private static readonly TOTAL_FIELDS = [
		'IdMonedaBase', 'SubTotal',
		'Envio', 'Igv',
		'Total'
	] as const;

	static compare(current: CartStorageDto | null, previous: CartStorageDto | null): boolean {
		if (!current && !previous)
			return true;
		if (!current || !previous)
			return false;
		return this.compareItems(current.items, previous.items) && this.compareCheckout(current.checkout, previous.checkout);
	}

	static compareItem(current: CartItemDto | null, previous: CartItemDto | null): boolean {
		if (!current && !previous)
			return true;
		if (!current || !previous)
			return false;
		return GeneralUtil.compareObjectFields(current, previous, this.ITEM_FIELDS);
	}

	static compareItems(current: CartItemDto[] | null, previous: CartItemDto[] | null
	): boolean {
		if (!current && !previous)
			return true;
		if (!current || !previous)
			return false;
		if (current.length !== previous.length)
			return false;

		const previousMap = new Map<number, CartItemDto>();
		previous.forEach(item =>
			previousMap.set(item.IdArticulo, item)
		);

		for (const currentItem of current) {
			const previousItem = previousMap.get(currentItem.IdArticulo);
			if (!previousItem) {
				return false;
			}
			if (!GeneralUtil.compareObjectFields(currentItem, previousItem, this.ITEM_FIELDS)) {
				return false;
			}
		}
		return true;
	}

	static compareCheckout(current: CartCheckoutDto | null, previous: CartCheckoutDto | null): boolean {
		if (!current && !previous)
			return true;
		if (!current || !previous)
			return false;
		return GeneralUtil.compareObjectFields(current, previous, this.CHECKOUT_FIELDS);
	}

	static compareTotals(current: CartTotalsDto | null, previous: CartTotalsDto | null): boolean {
		if (!current && !previous)
			return true;
		if (!current || !previous)
			return false;
		return GeneralUtil.compareObjectFields(current, previous, this.TOTAL_FIELDS)
	}
}